module.exports = __webpack_public_path__ + "static/media/pharmaflexrx-ultimate-package.25ca16af.png";